// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"7256e9ed","148":"476d2ef0","176":"8b60c026","524":"bb9f6466","596":"a432b9d5","784":"2447079f","840":"003bccf4","868":"1378b600"}[chunkId] + ".chunk.js";
};